import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router'
import NeighbordMap from '../Map/map'
import Slider from '../Slide'
import GalleryList from '../../../../components/Sections/Propiedades/PropiedadesList/Galeria'
import Propiedad from '../../../../containers/Sections/Propiedades/propiedad'
import MoreButton from '../../../../components/Buttons/plus'
import SliderHome from '../../../../components/Slider'
import { Col, Row } from 'react-bootstrap'
import Spinner from '../../../../components/Spinner'
import { translate } from "react-translate"
import { DIST_URL } from '../../../../constants/api';
import { MainBanner } from '../../../commons/MainBanner/MainBanner.component'

@translate("Barrio")
export default class Barrio extends Component {

  componentWillMount(){
    window.scrollTo(0, 0)
    this.props.resetPlaces()
    this.props.loadNeighborhoodDetails(this.props.params.id);
    this.props.loadProperties(this.props.params.id)

    this.renderBreadcrumb = this.renderBreadcrumb.bind(this)
  }

  _onViewMore(e) {
    this.props.findProperties()
    e.preventDefault();
    browserHistory.push("/propiedades")
  }

  renderBreadcrumb() {
    const { neighborhood, t } = this.props
    const baseUrl = window.location.origin;
    const barriosUrl = baseUrl + '/barrios';
    const barrioDetailUrl = baseUrl + '/barrios/' + neighborhood.id;

    return (<ol className="route-info-barrio hidden-xs" itemScope itemType="http://schema.org/BreadcrumbList">
      <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
        <a href={ baseUrl } itemProp="item" itemType="http://schema.org/Thing">
          <span itemProp="name"><small>{t("Informacion_Novedades")}</small></span>
          <meta itemProp="position" content="1" />
        </a>
      </li>
      
      <i className="fa fa-angle-right"></i>
      
      <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
        <a href={ barriosUrl } itemProp="item" itemType="http://schema.org/Thing">
          <span itemProp="name"><small>{t("Barrios")}</small></span>
          <meta itemProp="position" content="2" />
        </a>
      </li>
      
      <i className="fa fa-angle-right"></i>
      
      <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
        <a href={ barrioDetailUrl } itemProp="item" itemType="http://schema.org/Thing">
          <span itemProp="name"><small>{ neighborhood.name }</small></span>
          <meta itemProp="position" content="3" />
        </a>
      </li>
    </ol>)
  }

  render () {

    const { propertiesList,
            similarList,
            neighborhood,
            totalRent,
            totalSale,
            totalNeighborhoodRent,
            totalNeighborhoodSale,
            places,
						t
          } = this.props

    if (neighborhood) {

      let lat = neighborhood.location.lat
      let lng = neighborhood.location.lng

      let sliderContent = (neighborhood.images) ? <Slider gallery={neighborhood.images}/>  : ''

      var style = {
        backgroundImage: 'url(' + neighborhood.images[0] + ')'
      }

      var overlayStyle = {
        height: 480
      }


      console.log('similarList ', similarList)
      return (
        <div id="top" className="top" className="container-fluid">
          <div className="fluid-container barrios-view-container">
            <MainBanner
              backgroundURL={neighborhood.images[0]}
              mainTitle={neighborhood.name}
              renderBreadcrumb={this.renderBreadcrumb}
            >
            </MainBanner>
          </div>
          <div className="neighbord-information">
            <h3>{t("Informacion_acerca_de")} {neighborhood.name}</h3>
            <Row>
              <Col md={6} xs={12} className="neighbord-zone">
                <div className="title-zone hidden-xs">
                  <i className="fa fa-map-marker"></i>
                  <p>{neighborhood.name}</p>
                </div>
                <div className="zone-description hidden-xs">
                  <p>{neighborhood.description}</p>
                </div>
                <div className="zone-description visible-xs">
                  <p className="">{neighborhood.description}
                  </p>
                {/*<Button bsStyle="link">Ver más</Button>*/}
                </div>
              </Col>
              <Col md={6} xs={12} className="neighbord-slider">
                <div className="box-slider">
                  {sliderContent}
                </div>
              </Col>
            </Row>
          </div> 
          <div className="neighbord-map"> 
            { places.length > 0 ? (
                <div className="info-zone hidden-xs">
                  {places.map((item, index) =>
                    <div className="item-list" key={index}>
                      <i className={item.icon}></i>
                      <p>{item.cant}</p>  
                      <p>{item.name}</p>                 
                    </div>  
                  )}  
                </div>
              ) : ''
            }
            {(lat !== undefined && lng !== undefined) ? (
                <NeighbordMap zone={neighborhood.name} lat={lat} lng={lng} />
              ) : ''
            }
          </div>
          <div className="neighbord-caracteristics">
            <div className="title hidden-xs">
              <h3>{t("Caracteristicas_de_la_zona")}</h3>
              <img src={DIST_URL+'/assets/images/info-icon.png'} alt="LJRamos" />
            </div>
            <div className="cant-properties-info">
              <Col md={6} xs={12} className="left-col">
                <h3>{totalNeighborhoodRent}</h3>
                <p>{t("Propiedades_en_alquiler")}</p>
                <small>{t("sobre_un_total_de")} {totalRent}</small>
              </Col>
              <Col md={6} xs={12} className="right-col">
                <h3>{totalNeighborhoodSale}</h3>
                <p>{t("Propiedades_en_venta")}</p>
                <small>{t("sobre_un_total_de")} {totalSale}</small>
              </Col>
            </div>
          </div>
          <div className="zone-properties">
            <h3 className="zone-title">{t("Propiedades_en")} {neighborhood.name}</h3>
            <div className="row-properties-zone">
              {propertiesList.map((item, index) =>
                <Col md={3} sm={6} key={index}>
                  <Propiedad property={item}/>
                </Col>
              )}
            </div>
            {/* <div className="more-button">
              <MoreButton onClickMore={(e) => this._onViewMore(e)} />
            </div> */}
          </div>
          <div className="similar-properties hidden-xs">
            <div className='col-md-12'>
              <h3 className="zone-title">{t("Propiedades_similares_en_otros_barrios")} </h3>
              <SliderHome properties={similarList}/>
            </div>
          </div>
          {/* { (similarList.length > 0) ? (
            <div className="zone-properties propiedades-content similar visible-xs">
              <h3>{t("Propiedades_similares_en_otros_barrios")}</h3>
              <div className='col-md-12'>
                <GalleryList properties={similarList}/>
              </div>
            </div>
          ) : ''
          } */}
        </div>
      )
    }
    else{
      return(
        <Spinner />
      )
    }


  }
}



// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/components/NeighborhoodView/PageNeighborhoodView.component.js